window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        // when the page is loaded from bfcache, it can leave the dropdown menu open
        closeMenu();
    }
});


var menu_trigger = document.querySelector('.nav__toggle'),
    nav = document.querySelector('.nav'),
    body = document.querySelector('body'),
    nav_icon = document.querySelectorAll('.mega-nav__trigger'),
    sub_icon = document.querySelectorAll('.nav__icon--sub');

if (menu_trigger) {
    menu_trigger.addEventListener('click', handleMenuTrigger);
}

function handleMenuTrigger() {
    if (menu_trigger.classList.contains('nav__toggle--active')) {
        var openNavItem = nav.querySelector('.nav__link--active');
        if (openNavItem) {
            openNavItem.classList.remove('nav__link--active');
        }

        document.body.style.removeProperty("padding-right");
        document.removeEventListener(`keydown`, initTrapFocusNav);
    } else {
        document.addEventListener('keydown', initTrapFocusNav);
    }

    // Toggle classes
    menu_trigger.classList.toggle('nav__toggle--active');
    nav.classList.toggle('nav--active');
    body.classList.toggle('nav--open');


    // Accessibility
    if (menu_trigger.getAttribute('aria-expanded') === 'true') {
        menu_trigger.setAttribute('aria-expanded', 'false');
    } else {
        menu_trigger.setAttribute('aria-expanded', 'true');
    }
}

function openMenu() {
    document.addEventListener('keydown', initTrapFocusNav);

    // Toggle classes
    menu_trigger.classList.add('nav__toggle--active');
    nav.classList.add('nav--active');
    body.classList.add('nav--open');

    // Accessibility
    menu_trigger.setAttribute('aria-expanded', 'true');
}

function closeMenu() {
    var openNavItem = nav.querySelector('.nav__link--active');
    if (openNavItem) {
        openNavItem.classList.remove('nav__link--active');
    }

    document.body.style.removeProperty("padding-right");
    document.removeEventListener('keydown', initTrapFocusNav);


    // Toggle classes
    menu_trigger.classList.remove('nav__toggle--active');
    nav.classList.remove('nav--active');
    body.classList.remove('nav--open');


    // Accessibility
    menu_trigger.setAttribute('aria-expanded', 'false');
}

function initTrapFocusNav(e) {
    if (e.key === 'Escape') {
        var openNavItem = nav.querySelector('.nav__link--active')
        if (openNavItem) {
            openNavItem.classList.remove('nav__link--active');
        }

        document.body.style.removeProperty("padding-right");
        document.removeEventListener(`keydown`, initTrapFocusNav);

        menu_trigger.classList.remove('nav__toggle--active');
        nav.classList.remove('nav--active');
        body.classList.remove('nav--open');
        menu_trigger.setAttribute('aria-expanded', 'false');
    }

    trapFocus(e, 'header');
}

var navDropdowns = document.querySelectorAll('.nav__link--dropdown');
var navList = document.querySelector('.nav__list');

if (navDropdowns && navList) {
    navList.addEventListener('click', (e) => {
        if (e.target.classList.contains('nav__link--dropdown')) {

            let isDesktop = window.matchMedia("(min-width: 1025px)").matches;

            var clickedDropdown = e.target;

            if (clickedDropdown.classList.contains("nav__link--active")) {
                // closing dropdown
                e.target.classList.remove('nav__link--active');

                if (isDesktop) {
                    closeMenu();
                }
            } else {
                if (isDesktop) {
                    openMenu();
                }
                // opening dropdown
                var activeDropdowns = document.querySelectorAll(".nav__link--active");
                // want to close others first
                if (activeDropdowns) {
                    activeDropdowns.forEach((dropdown) => {
                        dropdown.classList.remove("nav__link--active");
                    })
                }

                clickedDropdown.classList.add("nav__link--active");
            }
        }
        if (e.target.classList.contains('nav__link--back')) {
            e.target.closest('.nav__dropdown').previousElementSibling.classList.remove('nav__link--active');
        }
    });
}

// TODO: clean up logic for show/hide nav and basket sidebar
var mainContent = document.getElementById("maincontent");

mainContent.addEventListener("click", () => {
    if (document.body.classList.contains("nav--open")) {
        document.body.style.removeProperty("padding-right");
        if (menu_trigger.classList.contains('nav__toggle--active')) {
            var openNavItem = nav.querySelector('.nav__link--active')
            if (openNavItem) {
                openNavItem.classList.remove('nav__link--active');
            }
        }

        // Toggle classes
        menu_trigger.classList.toggle('nav__toggle--active');
        nav.classList.toggle('nav--active');
        body.classList.toggle('nav--open');


        // Accessibility
        if (menu_trigger.getAttribute('aria-expanded') === 'true') {
            menu_trigger.setAttribute('aria-expanded', 'false');
        } else {
            menu_trigger.setAttribute('aria-expanded', 'true');
        }
    }
});

var currentPageLinks = document.querySelectorAll('a.nav__link--current');
if (currentPageLinks) {
    currentPageLinks.forEach((navLink) => {
        navLink.addEventListener('click', closeMenu);
    });
}


// sub level dropdowns
var subDropdownToggles = document.querySelectorAll('.js-nav-label-toggle');
subDropdownToggles?.forEach((dropdownToggle) => {
    dropdownToggle.addEventListener('click', (e) => {
        // close all items first
        document.querySelectorAll('.js-nav-label-toggle.nav__label--active').forEach(el => el.classList.remove('nav__label--active'));
        document.querySelectorAll('.nav__sub')?.forEach(el => el.classList.remove('nav__sub--active'));
        document.querySelectorAll('.nav__range-content')?.forEach(el => el.classList.remove('nav__range-content--active'));
        document.querySelectorAll('.js-nav-product-toggle.nav__product-label--active').forEach(el => el.classList.remove('nav__product-label--active'));
        document.querySelectorAll('.nav__product')?.forEach(el => el.classList.remove('nav__product--active'));

        // add active class to current dropdown label
        dropdownToggle.classList.add('nav__label--active');
        // add active class to corresponding dropdown menu
        var currentDropdown = dropdownToggle.closest('.nav__dropdown');
        var dropdownList = currentDropdown.querySelector(`.nav__sub[data-nav-child-index="${dropdownToggle.dataset.navChildIndex}"]`);
        dropdownList?.classList.add('nav__sub--active');
        // add active class to corresponding nav content
        var navContent = currentDropdown.querySelector(`.nav__range-content[data-nav-child-index="${dropdownToggle.dataset.navChildIndex}"]`);
        navContent?.classList.add('nav__range-content--active');
    });
});

// product level dropdowns
var productDropdownToggles = document.querySelectorAll('.js-nav-product-toggle');
productDropdownToggles?.forEach((dropdownToggle) => {
    dropdownToggle.addEventListener('click', (e) => {
        // close all items first
        document.querySelectorAll('.js-nav-product-toggle.nav__product-label--active').forEach(el => el.classList.remove('nav__product-label--active'));
        document.querySelectorAll('.nav__product')?.forEach(el => el.classList.remove('nav__product--active'));
        document.querySelectorAll('.nav__range-content')?.forEach(el => el.classList.remove('nav__range-content--active'));

        // add active class to current dropdown label
        dropdownToggle.classList.add('nav__product-label--active');
        // add active class to corresponding dropdown menu
        var currentDropdown = dropdownToggle.closest('.nav__dropdown');
        var parentIndex = dropdownToggle.closest('.nav__sub').dataset.navChildIndex;
        var dropdownList = currentDropdown.querySelector(`.nav__product[data-nav-child-index="${parentIndex}"][data-nav-product-index="${dropdownToggle.dataset.navChildIndex}"]`);
        dropdownList?.classList.add('nav__product--active');
    });
});

// handling removing active classes on load on mobile
document.addEventListener('DOMContentLoaded', function () {
    let isMobile = window.matchMedia("(max-width: 1024px)").matches;

    if (isMobile) {
        document.querySelector('.nav__sub--active')?.classList.remove('nav__sub--active');
        document.querySelector('.nav__range-content--active')?.classList.remove('nav__range-content--active');
        document.querySelector('.nav__label--active')?.classList.remove('nav__label--active');
    }
});